import { Team } from "resource-planner-model";
import { InviteSaveResult } from "../utils/invitationStatus";
export const FETCH_TEAMS = "teams/fetch";
export const LOAD_TEAMS = "teams/load";
export const REMOVE_TEAM = "teams/remove";
export const REMOVE_TEAM_LOCAL = "teams/remove_local";
export const PERSIST_TEAM = "teams/persist";
export const UPSERT_TEAM = "teams/upsert";

export interface TeamsState {
  items: { [id: string]: Team };
  loadedAll: boolean;
  nextToken?: string;
  synching: boolean;
}

export type PersistTeamResult = InviteSaveResult<Team>;

export interface FetchTeamsAction {
  type: typeof FETCH_TEAMS;
  append?: boolean;
  limit?: number;
  nextToken?: string;
  paginated?: boolean;
}

export interface LoadTeamsAction {
  type: typeof LOAD_TEAMS;
  append?: boolean;
  items: Team[];
  loadedAll?: boolean;
  nextToken?: string;
}

export interface RemoveTeamAction {
  type: typeof REMOVE_TEAM;
  id: string;
}

export interface RemoveTeamLocalAction {
  type: typeof REMOVE_TEAM_LOCAL;
  id: string;
}

export interface PersistTeamAction {
  type: typeof PERSIST_TEAM;
  item: Team;
}

export interface UpsertTeamAction {
  type: typeof UPSERT_TEAM;
  item: Team;
}

export type TeamAction =
  | FetchTeamsAction
  | LoadTeamsAction
  | RemoveTeamLocalAction
  | RemoveTeamAction
  | PersistTeamAction
  | UpsertTeamAction;
